import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { CanActivate, Router } from '@angular/router';
import { Observable, of, switchMap, take } from 'rxjs';
import { map } from 'rxjs';
import { UserService } from '../../core/user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router,
              private userService: UserService) {}

  canActivate(): Observable<boolean> {
    let isAuthenticated = false;
    let tokenInfo: any = {};
    return this.auth.isAuthenticated$.pipe(
      switchMap((auth) => {
        isAuthenticated = auth;
        if (!auth) return of(false);
        return this.auth.getAccessTokenSilently()
        .pipe(switchMap((token: string) => {
            tokenInfo.access_token = token;
            return this.auth.idTokenClaims$;
          }));
      }),
      switchMap((claims: any) => {
        if (!claims) return of(false)
        tokenInfo.company = localStorage.getItem('companyName') ?? 'No disponible';
        tokenInfo.id_token = claims.__raw;
        tokenInfo.scope = 'openid profile email';
        tokenInfo.expires_in = 86400;
        return this.userService.getToken(tokenInfo);
      }),
      map((res: any) => {
        if (!res) {
          this.router.navigate(['/login']);
          return false;
        }
        if (res.token) {
          return true;
        } else {
          this.router.navigate(['/login']);
          return false;
        }
      })
    )
  }
}
